import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getMenus } from 'src/api/getMenus/getMenus';
import { getMenusService } from 'src/services/getMenusService/getMenusService';
import type { IMenu } from 'src/types/menu.types';
import { QueryKeys } from '../QueryKeys';

export const useMenus = (options?: UseQueryOptions<IMenu[]>): UseQueryResult<IMenu[]> => {
  const { showSnackbar } = useSnackbar();

  return useQuery<IMenu[]>({
    queryKey: [QueryKeys.menus],
    queryFn: async () => {
      const data = await getMenus();
      const formattedMenus = getMenusService(data);
      return formattedMenus;
    },
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
    ...options,
  });
};
